import { outputAst } from '@angular/compiler';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  subTitle: string,
  description: string,
  descriptionArray: any,
  label1: string,
  label2: string,
  label3: string,
  supportTextForlabel3: string,
  positiveAction: CallableFunction,
  negativeAction: CallableFunction,
  action?: boolean,
  parent: any,
}
@Component({
  selector: 'warning-box',
  templateUrl: './warning-box.component.html',
  styleUrls: ['../dialog-box.scss']
})
export class WarningBoxComponent implements OnInit {
  set: boolean = false;
  subTitle: string = "The current task have issues";

  constructor(
    public dialogRef: MatDialogRef<WarningBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) { }

  negativeAction() {
    // this.data.action = false;
    if (this.data.negativeAction) {
      this.data.negativeAction(this.data.parent)
    }
    this.dialogRef.close(false);
  }

  positiveAction() {
    // this.data.action = true;
    if (this.data.positiveAction) {
      this.data.positiveAction(this.data.parent)
    }
    this.dialogRef.close(true);
  }

  extraAction(button3Text) {
    this.dialogRef.close(button3Text);
  }

  ngOnInit(): void {
  }

}
